var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSignOut = function SvgSignOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5c-5.511 0-10 4.489-10 10s4.489 10 10 10a10.04 10.04 0 0 0 6.941-2.778 1.002 1.002 0 0 0-.669-1.723 1 1 0 0 0-.713.277A8.038 8.038 0 0 1 12 20.5c-4.43 0-8-3.57-8-8s3.57-8 8-8c2.174 0 4.12.831 5.557 2.219a1 1 0 1 0 1.39-1.438C17.144 3.541 14.686 2.5 12 2.5Zm5.99 5.99a1 1 0 0 0-.697 1.717l1.293 1.293H9.5a1 1 0 1 0 0 2h9.086l-1.293 1.293a1 1 0 1 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3a1 1 0 0 0-.718-.303Z",
    fill: "#000"
  })));
};

export default SvgSignOut;